import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "list-table-container" }
const _hoisted_2 = {
  key: 0,
  style: {"position":"relative","z-index":"0"}
}
const _hoisted_3 = {
  key: 0,
  class: "list-table-header-cell",
  style: {"position":"relative","z-index":"999"}
}
const _hoisted_4 = {
  key: 1,
  class: "list-table-header-cell",
  style: {"position":"relative","z-index":"999"}
}
const _hoisted_5 = {
  key: 0,
  class: "list-table-column-cell"
}
const _hoisted_6 = {
  key: 1,
  class: "list-table-column-cell"
}
const _hoisted_7 = {
  key: 0,
  class: "no-data"
}
const _hoisted_8 = {
  key: 1,
  class: "list-table-main"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "list-table-header-cell"
}
const _hoisted_11 = {
  key: 1,
  class: "list-table-header-cell"
}
const _hoisted_12 = {
  key: 0,
  class: "list-table-column-cell"
}
const _hoisted_13 = {
  key: 1,
  class: "list-table-column-cell"
}
const _hoisted_14 = {
  key: 2,
  class: "no-data"
}
const _hoisted_15 = {
  key: 3,
  class: "padding10px"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "el-icon-delete" }, null, -1)
const _hoisted_17 = {
  key: 4,
  ref: "acionRef",
  class: "list-table-main list-table-action"
}
const _hoisted_18 = { class: "list-table-action-column" }
const _hoisted_19 = { class: "list-table-header-cell list-table-action-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_choose_column = _resolveComponent("choose-column")
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isOpenVirtual)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "list-table-virtual-wrap",
          onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scroll && _ctx.scroll(...args)))
        }, [
          _createVNode("ul", {
            class: "list-table-main",
            style: { 'padding-top': `${_ctx.scrollTop}px` }
          }, [
            (_ctx.showCheck === true || _ctx.showCheck === 'OnlyCheck')
              ? (_openBlock(), _createBlock("li", _hoisted_2, [
                  _createVNode(_component_choose_column, {
                    ref: "chooseColumn",
                    modelValue: _ctx.initCheck,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.initCheck = $event)),
                    "key-of-check": _ctx.keyOfCheck,
                    "table-data": _ctx.tableData,
                    "virtual-data": _ctx.virtualList,
                    "scroll-top": _ctx.scrollTop
                  }, null, 8, ["modelValue", "key-of-check", "table-data", "virtual-data", "scroll-top"])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.headers, (header, headerIndex) => {
              return (_openBlock(), _createBlock("li", {
                key: headerIndex,
                class: "list-table-column"
              }, [
                _createVNode("ul", null, [
                  (header.headerType === 'customize')
                    ? (_openBlock(), _createBlock("li", _hoisted_3, [
                        _renderSlot(_ctx.$slots, _ctx.getSlotName(header.name)+'Header', { scope: header })
                      ]))
                    : (_openBlock(), _createBlock("li", _hoisted_4, _toDisplayString(header.label), 1)),
                  _createVNode("div", {
                    style: { 'margin-top': `${-(_ctx.scrollTop%60)}px`,position: 'relative','z-index':0 }
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.virtualList, (tableItem) => {
                      return (_openBlock(), _createBlock(_Fragment, { key: tableItem }, [
                        (header.type === 'customize')
                          ? (_openBlock(), _createBlock("li", _hoisted_5, [
                              _renderSlot(_ctx.$slots, _ctx.getSlotName(header.name), { scope: tableItem })
                            ]))
                          : (_openBlock(), _createBlock("li", _hoisted_6, _toDisplayString(_ctx.filterEmptyCellValue(tableItem[header.name])), 1))
                      ], 64))
                    }), 128))
                  ], 4)
                ])
              ]))
            }), 128)),
            (_ctx.action !== false)
              ? (_openBlock(), _createBlock("li", {
                  key: 1,
                  style: {width: `${_ctx.actionWidth}px`},
                  class: "list-table-action-header"
                }, null, 4))
              : _createCommentVNode("", true)
          ], 4),
          (_ctx.tableData.length === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.$wordList.SelectNoData), 1))
            : _createCommentVNode("", true)
        ], 32))
      : (_openBlock(), _createBlock("ul", _hoisted_8, [
          (_ctx.showCheck === true || _ctx.showCheck === 'OnlyCheck')
            ? (_openBlock(), _createBlock("li", _hoisted_9, [
                _createVNode(_component_choose_column, {
                  modelValue: _ctx.initCheck,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.initCheck = $event)),
                  "key-of-check": _ctx.keyOfCheck,
                  "table-data": _ctx.tableData,
                  "disable-check-condition": _ctx.disableCheckCondition
                }, null, 8, ["modelValue", "key-of-check", "table-data", "disable-check-condition"])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.headers, (header, headerIndex) => {
            return (_openBlock(), _createBlock("li", {
              key: headerIndex,
              class: "list-table-column"
            }, [
              _createVNode("ul", null, [
                (header.headerType === 'customize')
                  ? (_openBlock(), _createBlock("li", _hoisted_10, [
                      _renderSlot(_ctx.$slots, _ctx.getSlotName(header.name)+'Header', { scope: header })
                    ]))
                  : (_openBlock(), _createBlock("li", _hoisted_11, _toDisplayString(header.label), 1)),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableData, (tableItem) => {
                  return (_openBlock(), _createBlock(_Fragment, { key: tableItem }, [
                    (header.type === 'customize')
                      ? (_openBlock(), _createBlock("li", _hoisted_12, [
                          _renderSlot(_ctx.$slots, _ctx.getSlotName(header.name), { scope: tableItem })
                        ]))
                      : (_openBlock(), _createBlock("li", _hoisted_13, _toDisplayString(_ctx.filterEmptyCellValue(tableItem[header.name])), 1))
                  ], 64))
                }), 128))
              ])
            ]))
          }), 128)),
          (_ctx.action !== false)
            ? (_openBlock(), _createBlock("li", {
                key: 1,
                style: {width: `${_ctx.actionWidth}px`},
                class: "list-table-action-header"
              }, null, 4))
            : _createCommentVNode("", true)
        ])),
    (_ctx.tableData.length === 0 && !_ctx.isOpenVirtual)
      ? (_openBlock(), _createBlock("div", _hoisted_14, _toDisplayString(_ctx.$wordList.SelectNoData), 1))
      : _createCommentVNode("", true),
    (_ctx.showCheck === true)
      ? (_openBlock(), _createBlock("div", _hoisted_15, [
          _createVNode(_component_cus_button, {
            type: "iconread",
            onClick: _ctx.multipleDelete
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.action !== false)
      ? (_openBlock(), _createBlock("ul", _hoisted_17, [
          _createVNode("li", _hoisted_18, [
            _createVNode("ul", null, [
              _createVNode("li", _hoisted_19, _toDisplayString(_ctx.actionList.length > 1 ? _ctx.$wordList.ProperAllTextActions : _ctx.$wordList.CaptureListTanleAction), 1),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableData, (dataItem, dataIndex) => {
                return (_openBlock(), _createBlock("li", {
                  key: dataIndex,
                  class: "list-table-column-cell"
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.actionList, (item) => {
                    return (_openBlock(), _createBlock(_Fragment, { key: item }, [
                      (_ctx.defaultActionType.includes(item.type))
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            (_ctx.showDefaultAction.includes(item.type))
                              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                  (item.type === 'delete')
                                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                        (!item.showCondition ||
                                                (item.showCondition &&
                                                    item.showCondition(_ctx.requestDetail[dataIndex])))
                                          ? (_openBlock(), _createBlock("i", {
                                              key: 0,
                                              class: ["list-icon", _ctx.actionClass[item.type]],
                                              title: item.title,
                                              onClick: ($event: any) => (_ctx.deleteActionEvent(item, _ctx.requestDetail[dataIndex]))
                                            }, null, 10, ["title", "onClick"]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                        (!item.showCondition ||
                                                (item.showCondition &&
                                                    item.showCondition(_ctx.requestDetail[dataIndex])))
                                          ? (_openBlock(), _createBlock("i", {
                                              key: 0,
                                              class: ["list-icon", _ctx.actionClass[item.type]],
                                              title: item.title,
                                              onClick: ($event: any) => (_ctx.actionEvent(item, _ctx.requestDetail[dataIndex]))
                                            }, null, 10, ["title", "onClick"]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            (!item.showCondition ||
                                        (item.showCondition &&
                                            item.showCondition(_ctx.requestDetail[dataIndex])))
                              ? (_openBlock(), _createBlock("i", {
                                  key: 0,
                                  class: ["list-icon", item.class],
                                  title: item.title,
                                  onClick: ($event: any) => (_ctx.actionEvent(item, _ctx.requestDetail[dataIndex]))
                                }, null, 10, ["title", "onClick"]))
                              : _createCommentVNode("", true)
                          ], 64))
                    ], 64))
                  }), 128))
                ]))
              }), 128))
            ])
          ])
        ], 512))
      : _createCommentVNode("", true)
  ]))
}